import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Divider, Text } from '@chakra-ui/react';

import { useGetUserQuery } from '../../../../api/endpoints/users-endpoint';
import { IMessageToolCall } from '../../../../api/types';
import { useAppSelector } from '../../../../redux/hooks/app-hooks';

import { AssistantToolCall } from './ToolCall/AssistantToolCall';

import styles from './EnhancedMessage.module.scss';

export type ToolCallsProps = {
    toolCalls?: IMessageToolCall[];
};

export const ToolCalls: React.FC<ToolCallsProps> = ({ toolCalls }) => {
    const { t } = useTranslation('translations');
    const project = useAppSelector((state) => state.settings.project);
    const { data: user } = useGetUserQuery(undefined);

    const customerName =
        user?.customer_projects.find((p) => p.value === project)?.text ?? t('chat-tab.customer-name-default');

    if (!toolCalls?.length) {
        return null;
    }

    return (
        <AccordionItem borderColor="transparent">
            <Box className={styles.accordionHeader}>
                <AccordionButton>
                    <AccordionIcon />
                </AccordionButton>
                <Text className={styles.title}>
                    {t('chat-tab.analyzing-resources', { customer_name: customerName })}
                </Text>
            </Box>

            <AccordionPanel>
                {toolCalls.map((toolCall, index) => (
                    <Fragment key={toolCall?.tool_call_id ?? index}>
                        <AssistantToolCall
                            toolCall={toolCall}
                            key={`${toolCall.function_name}_${toolCall.function_args}`}
                        />
                        {index < toolCalls.length - 1 && <Divider margin="8px" height="1px" />}
                    </Fragment>
                ))}
            </AccordionPanel>
        </AccordionItem>
    );
};
